module.exports = __webpack_public_path__ + "493905822a52165f6ebea664f706b57e.MP3";